import React, { useState, useRef } from "react";
import useTableScroll from "../../useTableScrollcesar";
import { Mensaje, MensajeSiNo } from "../../mensajes2";
import { Dimmer } from "../../spinner";
import axios from "axios";
import moment from "moment";
import Modal from "react-bootstrap/Modal";
import { formatMoneda, validaSoloNumero } from "../../../util/varios";
import CatalogoComercio from "../../../catalogos/catalogoComercio";
//UI
import { Input, SearchInput, Select, Textarea } from "../../../ui/inputs/Input";
import { DangerButton, SuccessButton } from "../../../ui/buttons/Button";

export const FacturaMultaPago = (props) => {
  moment.locale("es-us");
  const fechaSistema = JSON.parse(localStorage.getItem("fechasistema"));
  const idusuario = JSON.parse(localStorage.getItem("idusuario"));

  const cmbTipoImpuesto = useRef();
  const txtContribuyente = useRef();
  const chkSeleccionarDeuda = useRef([]);

  const [idTipIngre, setIdTipIngre] = useState();
  const [idTipIngreMulta] = useState();
  const [nomTablaContri, setNomTablaContri] = useState();
  const [tipoImpu, setTipoImpu] = useState(0);
  const [tipoImpuesto, setTipoImpuesto] = useState([]);
  const [idComercio, setIdComercio] = useState(0);
  const [factorCambio, setFactorCambio] = useState(0);

  const [disponiblesDeuda, setDisponiblesDeuda] = useState(0);
  const [catalogoC, setCatalogoC] = useState(false);

  const [cuentasBanca, setCuentasBanca] = useState("0");
  const [tabla] = useState(null);
  const [tipoPago, setTipoPago] = useState("");
  const [efectivo1, setEfectivo1] = useState("0,00");
  const [efectivo2, setEfectivo2] = useState("0,00");
  const [fechaD1, setFechaD1] = useState("");
  const [fechaD2, setFechaD2] = useState("");
  const [numeroD1, setNumeroD1] = useState("");
  const [numeroD2, setNumeroD2] = useState("");
  const [montoT1, setMontoT1] = useState("0,00");
  const [montoT2, setMontoT2] = useState("0,00");
  const [montoT3, setMontoT3] = useState("0,00");
  const [fechaT1, setFechaT1] = useState("");
  const [fechaT2, setFechaT2] = useState("");
  const [fechaT3, setFechaT3] = useState("");
  const [numeroT1, setNumeroT1] = useState("");
  const [numeroT2, setNumeroT2] = useState("");
  const [numeroT3, setNumeroT3] = useState("");
  const [banCliT1, setBanCliT1] = useState("0");
  const [banCliT2, setBanCliT2] = useState("0");
  const [banCliT3, setBanCliT3] = useState("0");

  const [titulo] = useState();
  const [msg] = useState();
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [visibleF, setVisibleF] = useState("hidden");
  const [etiqueta, setEtiqueta] = useState("N° de Ritm:");
  const [activate, setActivate] = useState(false);
  const [btnDisabled, setBtnDisabled] = useState(true);
  const [idcontribuyente] = useState(null);
  const [deuda, setDeuda] = useState([]);
  const [multa, setMulta] = useState([]);
  const [disabledMulta, setDisabledMulta] = useState(false);
  const [totalSelect, setTotalSelect] = useState({
    concepto: "",
    seleccionados: "",
    montoseleccionado: "",
    acrediSelect: "",
    montoFacturadoSelect: "",
    interesesSelect: "",
    multaSelect: "",
    recargoSelect: "",
    retenSelect: "",
  });

  const [valuess, setValuess] = useState({
    idcontribuyente: "",
    nombre: "",
    rif: "",
    direccion: "",
  });
  let token = localStorage.getItem("jwtToken");
  let op = require("../../../../src/modulos/datos");

  const headCells = [
    { label: "#", textAlign: "center" },
    { label: "Fecha", textAlign: "center" },
    { label: "Tipo", textAlign: "center" },
    { label: "Concepto", textAlign: "center" },
    { label: "Monto", textAlign: "center" },
  ];

  const { TblContainer, TblHead } = useTableScroll(headCells);

  const onChange = (e) => {
    valuess.nombre = "";
    valuess.direccion = "";
    valuess.cedrif = "";
    valuess.ritm = "";
    setTotalSelect({
      concepto: "",
      seleccionados: "",
      montoseleccionado: "",
      acrediSelect: "",
      montoFacturadoSelect: "",
      interesesSelect: "",
      multaSelect: "",
      recargoSelect: "",
      retenSelect: "",
    });
    setDeuda([]);
    setVisibleF("hidden");
    setValuess({ ...valuess, [e.target.name]: e.target.value });
    if (e.target.name === "idcontribuyente") {
      validaSoloNumero(e);
    }
  };

  const seleccionartipoIngreso = () => {
    setActivate(true);
    let campos = "*";
    let nomtab = "tipoimpuesto";
    let nomid = "tipofacturacion";
    let id = "3";
    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.idtipoingreso > 0) {
            setIdTipIngre(response.data.idtipoingreso);
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const seleccionartipoRenta = (id) => {
    let campos = "*";
    let nomtab = "tiporentas";
    let nomid = "idtiporentas";
    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.idtiporentas > 0) {
            valuess.ritm =
              response.data.descripcion === null
                ? ""
                : response.data.descripcion.trim();
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const seleccionarFactorCambio = () => {
    let endpoint = `${op.conexion}/api/vehiculo/factorcambio`;
    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          console.log(response.data);
          setFactorCambio(response.data.valor);
        }
      })
      .catch(function (error) {
        setActivate(false);
      });
  };

  const selectTipoImpuesto = (e) => {
    setValuess({
      idcontribuyente: "",
      nombre: "",
      direccion: "",
      rif: "",
      ritm: "",
    });
    setTotalSelect({
      concepto: "",
      seleccionados: "",
      montoseleccionado: "",
      acrediSelect: "",
      montoFacturadoSelect: "",
      interesesSelect: "",
      multaSelect: "",
      recargoSelect: "",
      retenSelect: "",
    });
    setVisibleF("hidden");
    txtContribuyente.current.value = "";
    setTipoImpuesto(
      cmbTipoImpuesto.current[cmbTipoImpuesto.current.selectedIndex].text
    );
    setTipoImpu(parseInt(e.target.value));
  };

  const SelectDeuda = (id, nomtab) => {
    let camp = "*";
    let tabla = "multa";
    let nombreid = "idcontribuyente";
    let nombreid2 = "tablacontribuyente";
    let valorid2 = nomtab;
    let nombreid3 = "tipoimpuesto";
    let valorid3 = tipoImpuesto;
    let endpoint = `${op.conexion}/api/consulta/modeli3string?campos=${camp}&id=${id}&nomtab=${tabla}&nomid=${nombreid}&nomid2=${nombreid2}&id2=${valorid2}&nomid3=${nombreid3}&id3=${valorid3}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          var deu = [];
          //var his = [];
          for (let i = 0; i < response.data.length; i++) {
            if (
              response.data[i].cancelada === false ||
              response.data[i].cancelada === null
            ) {
              deu.push({
                fechamulta: response.data[i].fechamulta,
                monto: response.data[i].monto * factorCambio,
                status: "Por Pagar",
                descripcion: response.data[i].descripcion,
                concepto: response.data[i].concepto,
                iddeuda: response.data[i].idmulta,
              });
            } else {
            }
          }
          setDeuda(deu);
        }
        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const SelectIdComercioFact = (idinmue) => {
    let endpoint = `${op.conexion}/api/Caja_Ingreso/selectIdComercioFactura?idinmue=${idinmue}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setIdComercio(
            response.data.idcomercio === null ? 0 : response.data.idcomercio
          );
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const procesarFactura = (body) => {
    let endpoint = `${op.conexion}/api/Caja_Ingreso/crearfactura`;
    setActivate(true);
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        setActivate(false);
        if (response.status == 200) {
          valuess.idcontribuyente = "";
          valuess.rif = "";
          valuess.nombre = "";
          valuess.direccion = "";
          props.onHideAcepta();
          blanquear();
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(function () {
        setActivate(false);
      });
  };

  const procesarpago = (body) => {
    let endpoint = `${op.conexion}/api/agenteweb/procesarpago`;
    setActivate(true);
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setMensaje({
            mostrar: true,
            titulo: "Exito.",
            texto:
              "Estimado contribuyente, hacemos de su conocimiento que el procedimiento de verificación de pago tiene un tiempo estimado de 72 horas, una vez conciliado el mismo, será enviado vía correo electrónico, el correspondiente certificado de pago definitivo; valoramos y agradecemos su contribución para lograr el Municipio de lo Posible.",
            icono: "exito",
          });
          var idfactura = response.data.idfactu;
          var titulo =
            response.data.statusfac === 1
              ? "Certificado de Pago Electrónico"
              : "";
          var estatus = response.data.statusfac === 1 ? "'-2'" : "0";
          var certificado = response.data.statusfac === 1 ? "true" : "false";
          var tipo = response.data.tipotran === 1 ? "Depo" : "Trans";
          window.open(
            op.reportes +
              "FACTURA=" +
              idfactura +
              "&titulo=" +
              titulo +
              "&estatus=" +
              estatus +
              "&certificado=" +
              certificado +
              "&reporte=" +
              tipo,
            "Planilla",
            "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
          );
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(function () {
        setActivate(false);
      });
  };

  const chandleCheckDeuda = (item, index) => (e) => {
    var deu = [...deuda];
    var montoseleccionado = 0.0;
    var montoFacturadoSelect = 0.0;
    var interesesSelect = "0.00";
    var multaSelect = 0.0;
    var recargoSelect = "0.00";
    var retenSelect = 0.0;
    var acrediSelect = 0.0;
    var per = "PAGO DE MULTA POR ";
    var periodofac = "";
    var seleccionados = 0;
    var periodo = "";
    var continua = true;

    if (chkSeleccionarDeuda.current[index].checked === true) {
      for (let i = 0; i < chkSeleccionarDeuda.current.length; i++) {
        if (i !== index) {
          chkSeleccionarDeuda.current[i].checked = false;
          deu[i].status = "Por Pagar";
        }
      }
      //periodo = ' CORRESPONDIENTE AL PERIODO ' + item.mes + ' / ' + item.anio + ' ';

      //per = per + ' ' + item.descripcion.trim() + (item.ubicacion === '' || item.ubicacion === null ? '' : ' UBICADO EN ' + item.ubicacion.trim()) + periodo;
      per = per + item.descripcion.trim() + " " + item.concepto.trim();
      seleccionados = seleccionados + 1;
      periodofac =
        periodofac +
        item.fechamulta.substring(0, 4) +
        " / " +
        item.fechamulta.substring(5, 7);
      montoseleccionado =
        parseFloat(montoseleccionado) + parseFloat(item.monto);
      montoseleccionado =
        Math.round(montoseleccionado * Math.pow(10, 2)) / Math.pow(10, 2);
      acrediSelect = parseFloat(acrediSelect) + parseFloat(item.credito);
      acrediSelect =
        Math.round(acrediSelect * Math.pow(10, 2)) / Math.pow(10, 2);
      montoFacturadoSelect =
        parseFloat(montoFacturadoSelect) + parseFloat(item.monto);
      montoFacturadoSelect =
        Math.round(montoFacturadoSelect * Math.pow(10, 2)) / Math.pow(10, 2);
      //interesesSelect = parseFloat(interesesSelect) + parseFloat(item.intereses);
      //interesesSelect = Math.round(interesesSelect * Math.pow(10, 2)) / Math.pow(10, 2);
      multaSelect = parseFloat(multaSelect) + parseFloat(item.multa);
      multaSelect = Math.round(multaSelect * Math.pow(10, 2)) / Math.pow(10, 2);
      //recargoSelect = parseFloat(recargoSelect) + parseFloat(item.recargo);
      //recargoSelect = Math.round(recargoSelect * Math.pow(10, 2)) / Math.pow(10, 2);
      retenSelect = parseFloat(retenSelect) + parseFloat(item.retenciones);
      retenSelect = Math.round(retenSelect * Math.pow(10, 2)) / Math.pow(10, 2);
    } else {
      per = "";
      seleccionados = 0;
      periodofac = "";
      montoseleccionado = 0.0;
      //montoseleccionado = Math.round(montoseleccionado * Math.pow(10, 2)) / Math.pow(10, 2);
      acrediSelect = 0.0;
      //acrediSelect = Math.round(acrediSelect * Math.pow(10, 2)) / Math.pow(10, 2);
      montoFacturadoSelect = 0.0;
      //montoFacturadoSelect = Math.round(montoFacturadoSelect * Math.pow(10, 2)) / Math.pow(10, 2);
      interesesSelect = 0.0;
      //interesesSelect = Math.round(interesesSelect * Math.pow(10, 2)) / Math.pow(10, 2);
      multaSelect = 0.0;
      //multaSelect = Math.round(multaSelect * Math.pow(10, 2)) / Math.pow(10, 2);
      recargoSelect = 0.0;
      //recargoSelect = Math.round(recargoSelect * Math.pow(10, 2)) / Math.pow(10, 2);
      retenSelect = 0.0;
      //retenSelect = Math.round(retenSelect * Math.pow(10, 2)) / Math.pow(10, 2);
    }

    if (item.status === "Por Pagar") {
      item.status = "Listo";
      setDisponiblesDeuda(disponiblesDeuda - 1);
    } else if (item.status === "Listo") {
      item.status = "Por Pagar";
      //setDisponiblesDeuda(disponiblesDeuda + 1);
    }
    /*deu[index] = item;

        setDeuda(deu);*/

    setTotalSelect({
      concepto: per,
      seleccionados: seleccionados,
      montoseleccionado: formatMoneda(
        montoseleccionado.toString().replace(".", ","),
        ",",
        ".",
        2
      ),
      acrediSelect: formatMoneda(
        acrediSelect.toString().replace(".", ","),
        ",",
        ".",
        2
      ),
      montoFacturadoSelect: formatMoneda(
        montoFacturadoSelect.toString().replace(".", ","),
        ",",
        ".",
        2
      ),
      interesesSelect: formatMoneda(
        interesesSelect.toString().replace(".", ","),
        ",",
        ".",
        2
      ),
      multaSelect: formatMoneda(
        multaSelect.toString().replace(".", ","),
        ",",
        ".",
        2
      ),
      recargoSelect: formatMoneda(
        recargoSelect.toString().replace(".", ","),
        ",",
        ".",
        2
      ),
      retenSelect: formatMoneda(
        retenSelect.toString().replace(".", ","),
        ",",
        ".",
        2
      ),
    });

    if (seleccionados > 0) {
      setBtnDisabled(false);
    } else {
      setBtnDisabled(true);
    }
  };

  const procesarPagoWeb = () => {
    var nAnio = [];
    var nMes = [];
    var nMonto = [];
    var nInteres = [];
    var nMulta = [];
    var nRecargo = [];
    var nTotal = [];
    var cIdFact = [];
    var cNumPlani = [];
    var cPeri = [];
    var tdeu = [];
    var iddeu = [];
    var tipod = [];

    if (disabledMulta) {
      for (let i = 0; i < deuda.length; i++) {
        var sigue = deuda[i].status;
        if (sigue === "Listo") {
          nAnio.push(deuda[i].anio);
          nMes.push(deuda[i].nummes);
          nMonto.push(deuda[i].monto);
          nInteres.push(deuda[i].intereses);
          nMulta.push(deuda[i].multa);
          nRecargo.push(deuda[i].recargo);
          nTotal.push(deuda[i].totalperi);
          cIdFact.push(deuda[i].idfact);
          cNumPlani.push(deuda[i].planilla);
          cPeri.push(deuda[i].periodo);
          tdeu.push(deuda[i].tipodeuda);
          iddeu.push(parseInt(deuda[i].iddeu));
          tipod.push(deuda[i].tipod);
        }
      }
    } else {
      for (let i = 0; i < multa.length; i++) {
        var sigue = multa[i].status;
        if (sigue === "Listo") {
          nAnio.push(multa[i].anio);
          nMes.push(multa[i].nummes);
          nMonto.push(multa[i].monto);
          nInteres.push(multa[i].intereses);
          nMulta.push(multa[i].multa);
          nRecargo.push(multa[i].recargo);
          nTotal.push(multa[i].totalperi);
          cIdFact.push(multa[i].idfact);
          cNumPlani.push(multa[i].planilla);
          cPeri.push(multa[i].periodo);
          tdeu.push(multa[i].tipodeuda);
          iddeu.push(parseInt(multa[i].iddeu));
          tipod.push(multa[i].tipod);
        }
      }
    }

    var tipPago = tipoPago === "deposito" ? 1 : 2;

    var body = {
      idcontri: idcontribuyente,
      fechasis: fechaSistema,
      idimpu: tabla && tabla.idtipoimpuesto,
      mont: totalSelect.montoseleccionado.replace(/\./g, "").replace(",", "."),
      tipo: tipPago,
      cuenta: cuentasBanca,
      totaldescuento: "0.00",
      txtfecha1:
        fechaD1 === "" ? fechaD1 : moment.utc(fechaD1).format("YYYY-MM-DD"),
      txtnumdepo1: numeroD1,
      txtmontoefec1: efectivo1.replace(/\./g, "").replace(",", "."),
      txtfecha2:
        fechaD2 === "" ? fechaD2 : moment.utc(fechaD2).format("YYYY-MM-DD"),
      txtnumdepo2: numeroD2,
      txtmontoefec2: efectivo2.replace(/\./g, "").replace(",", "."),
      txtfechatran1:
        fechaT1 === "" ? fechaT1 : moment.utc(fechaT1).format("YYYY-MM-DD"),
      txtnumtran1: numeroT1,
      bcliente1: banCliT1,
      txtmontotran1: montoT1.replace(/\./g, "").replace(",", "."),
      txtfechatran2:
        fechaT2 === "" ? fechaT2 : moment.utc(fechaT2).format("YYYY-MM-DD"),
      txtnumtran2: numeroT2,
      bcliente2: banCliT2,
      txtmontotran2: montoT2.replace(/\./g, "").replace(",", "."),
      txtfechatran3:
        fechaT3 === "" ? fechaT3 : moment.utc(fechaT3).format("YYYY-MM-DD"),
      txtnumtran3: numeroT3,
      bcliente3: banCliT3,
      txtmontotran3: montoT3.replace(/\./g, "").replace(",", "."),
      ctotmonto: totalSelect.montoFacturadoSelect
        .replace(/\./g, "")
        .replace(",", "."),
      ctotint: totalSelect.interesesSelect.replace(/\./g, "").replace(",", "."),
      ctotrec: totalSelect.recargoSelect.replace(/\./g, "").replace(",", "."),
      ctotmulta: totalSelect.multaSelect.replace(/\./g, "").replace(",", "."),
      ctotrete: totalSelect.retenSelect.replace(/\./g, "").replace(",", "."),
      txtconcepto: totalSelect.concepto,
      panio: nAnio,
      pmes: nMes,
      pmonto: nMonto,
      pinteres: nInteres,
      pmulta: nMulta,
      precargo: nRecargo,
      ptotal: nTotal,
      tdeu,
      iddeu,
      tipod,
    };

    procesarpago(body);
  };

  const handleCloseSi = () => {
    procesarPagoWeb();
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
  };

  const blanquear = () => {
    setMulta([]);
    setDeuda([]);
    setDisponiblesDeuda(0);
    setBtnDisabled(true);
    setDisabledMulta(false);
    setCuentasBanca("0");
    setTipoPago("");
    setEfectivo1("0,00");
    setFechaD1("");
    setNumeroD1("");
    setEfectivo2("0,00");
    setFechaD2("");
    setNumeroD2("");
    setFechaT1("");
    setNumeroT1("");
    setBanCliT1("0");
    setMontoT1("0,00");
    setFechaT2("");
    setNumeroT2("");
    setBanCliT2("0");
    setMontoT2("0,00");
    setFechaT3("");
    setNumeroT3("");
    setBanCliT3("0");
    setMontoT3("0,00");
    setTotalSelect({
      concepto: "",
      seleccionados: "",
      montoseleccionado: "",
      acrediSelect: "",
      montoFacturadoSelect: "",
      interesesSelect: "",
      multaSelect: "",
      recargoSelect: "",
      retenSelect: "",
    });
  };

  const handleCatalogo = () => {
    switch (tipoImpu) {
      case 0:
      case 1:
        if (!catalogoC) {
          setCatalogoC(true);
        } else {
          setCatalogoC(false);
        }
        break;

      default:
        break;
    }
  };

  const handleAceptaCatalogo = (id) => {
    switch (tipoImpu) {
      case 0:
      case 1:
        setCatalogoC(false);
        break;
      default:
        break;
    }
    datosContribuyente(id);
  };

  const datosContribuyente = (idcontri) => {
    if (tipoImpu === 0) {
      setMensaje({
        mostrar: true,
        titulo: "Error",
        texto: "Debe seleccionar el tipo de Multa.",
        icono: "error",
      });
      return;
    }
    let nomid = "";
    let nomtab = "";
    let tipo = 1;
    setIdComercio(0);
    switch (tipoImpu) {
      case 1:
        tipo = 1;
        nomtab = "comercio";
        nomid = "idcomercio";
        setNomTablaContri("comercio");
        break;
      case 2:
        tipo = 1;
        setNomTablaContri("inmueble");
        nomtab = "inmueble";
        nomid = "idinmueble";
        break;
      case 3:
        tipo = 1;
        setNomTablaContri("vehiculo");
        nomtab = "vehiculo";
        nomid = "idvehiculo";
        break;
      case 4:
        tipo = 1;
        setNomTablaContri("comercio");
        nomtab = "comercio";
        nomid = "idcomercio";
        break;
      case 5:
        //codimpu = 3;
        tipo = 3;
        setNomTablaContri("comercio");
        nomtab = "comercio";
        nomid = "idcomercio";
        break;
      case 6:
        //codimpu = 0;
        tipo = 2;
        setNomTablaContri("rentasinmobiliarias");
        nomtab = "rentasinmobiliarias";
        nomid = "idrentas";
        break;
      case 7:
        //codimpu = 2;
        tipo = 2;
        setNomTablaContri("comercio");
        nomtab = "comercio";
        nomid = "idcomercio";
        break;
    }

    let campos = "*";
    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${idcontri}&nomtab=${nomtab}&nomid=${nomid}`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data !== "") {
            setActivate(false);
            switch (tipoImpu) {
              case 1:
                txtContribuyente.current.value = response.data.idcomercio;
                valuess.rif = response.data.rif;
                valuess.nombre = response.data.nombre;
                valuess.direccion = response.data.direccion;
                valuess.ritm =
                  response.data.ritm === null ? "" : response.data.ritm.trim();
                setEtiqueta("Nº de Ritm");
                setVisibleF("visible");
                //SelectDeuda(txtContribuyente.current.value, nomtab);

                break;
              case 2:
                txtContribuyente.current.value = response.data.idinmueble;
                valuess.rif =
                  response.data.cedulapropie === null
                    ? ""
                    : response.data.cedulapropie.trim();
                valuess.nombre =
                  response.data.nombrepropie === null
                    ? ""
                    : response.data.nombrepropie.trim();
                valuess.direccion =
                  (response.data.dirinmue1 == null
                    ? ""
                    : response.data.dirinmue1.trim().toLowerCase() === "null"
                    ? ""
                    : response.data.dirinmue1.trim().toLowerCase() === ""
                    ? ""
                    : response.data.dirinmue1 !== null
                    ? response.data.dirinmue1.trim()
                    : "") +
                  " " +
                  (response.data.descridirinmue1 === null
                    ? ""
                    : response.data.descridirinmue1.trim().toLowerCase() ===
                      "null"
                    ? ""
                    : response.data.descridirinmue1.trim().toLowerCase() === ""
                    ? ""
                    : response.data.descridirinmue1 !== null
                    ? response.data.descridirinmue1.trim()
                    : "") +
                  " " +
                  (response.data.dirinmue2 === null
                    ? ""
                    : response.data.dirinmue2.trim().toLowerCase() === "null"
                    ? ""
                    : response.data.dirinmue2.trim().toLowerCase() === ""
                    ? ""
                    : response.data.dirinmue2 !== null
                    ? response.data.dirinmue2.trim()
                    : "") +
                  " " +
                  (response.data.descridirinmue2 === null
                    ? ""
                    : response.data.descridirinmue2.trim().toLowerCase() ===
                      "null"
                    ? ""
                    : response.data.descridirinmue2.trim().toLowerCase() === ""
                    ? ""
                    : response.data.descridirinmue2 !== null
                    ? response.data.descridirinmue2.trim()
                    : "") +
                  " " +
                  (response.data.ubicacionterreno === null
                    ? ""
                    : !response.data.ubicacionterreno.trim() === "ESQUINA"
                    ? (response.data.dirinmue3 === null
                        ? ""
                        : response.data.dirinmue3.trim().toLowerCase() ===
                          "null"
                        ? ""
                        : response.data.dirinmue3.trim().toLowerCase() === ""
                        ? ""
                        : response.data.dirinmue3 !== null
                        ? " ENTRE" + " " + response.data.dirinmue3.trim()
                        : "") +
                      " " +
                      (response.data.descridirinmue3 === null
                        ? ""
                        : response.data.descridirinmue3.trim().toLowerCase() ===
                          "null"
                        ? ""
                        : response.data.descridirinmue3.trim().toLowerCase() ===
                          ""
                        ? ""
                        : response.data.descridirinmue3 !== null
                        ? response.data.descridirinmue3.trim()
                        : "") +
                      " " +
                      (response.data.dirinmue4 === null
                        ? ""
                        : response.data.dirinmue4.trim().toLowerCase() ===
                          "null"
                        ? ""
                        : response.data.dirinmue4.trim().toLowerCase() === ""
                        ? ""
                        : response.data.dirinmue4 !== null
                        ? "Y" + " " + response.data.dirinmue4.trim()
                        : "") +
                      " " +
                      (response.data.descridirinmue4 === null
                        ? ""
                        : response.data.descridirinmue4.trim() === "null"
                        ? ""
                        : response.data.descridirinmue4.trim().toLowerCase() ===
                          "null"
                        ? ""
                        : response.data.descridirinmue4.trim().toLowerCase() ===
                          ""
                        ? ""
                        : response.data.descridirinmue4 !== null
                        ? response.data.descridirinmue4.trim()
                        : "") +
                      " "
                    : (response.data.dirinmue3 === null
                        ? ""
                        : response.data.dirinmue3.trim().toLowerCase() ===
                          "null"
                        ? ""
                        : response.data.dirinmue3.trim().toLowerCase() === ""
                        ? ""
                        : response.data.dirinmue3 !== null
                        ? " ESQUINA" + " " + response.data.dirinmue3.trim()
                        : "") +
                      " " +
                      (response.data.descridirinmue3 === null
                        ? ""
                        : response.data.descridirinmue3.trim().toLowerCase() ===
                          "null"
                        ? ""
                        : response.data.descridirinmue3.trim().toLowerCase() ===
                          ""
                        ? ""
                        : response.data.descridirinmue3 !== null
                        ? response.data.descridirinmue3.trim()
                        : "") +
                      " ") +
                  (response.data.dirinmue5 === null
                    ? ""
                    : response.data.dirinmue5.trim().toLowerCase() === "null"
                    ? ""
                    : response.data.dirinmue5.trim().toLowerCase() === ""
                    ? ""
                    : response.data.dirinmue5 !== null
                    ? response.data.dirinmue5.trim()
                    : "") +
                  " " +
                  (response.data.descridirinmue5 === null
                    ? ""
                    : response.data.descridirinmue5.trim().toLowerCase() ===
                      "s/nombre"
                    ? ""
                    : response.data.descridirinmue5.trim().toLowerCase() === ""
                    ? ""
                    : response.data.descridirinmue5 !== null
                    ? response.data.descridirinmue5.trim()
                    : ""
                  ).trim() +
                  " " +
                  (response.data.numcivicoinmue === null
                    ? ""
                    : response.data.numcivicoinmue.trim().toLowerCase() ===
                      "s/n"
                    ? ""
                    : response.data.numcivicoinmue.trim().toLowerCase() === ""
                    ? ""
                    : response.data.numcivicoinmue !== null
                    ? " Nº" + " " + response.data.numcivicoinmue.trim()
                    : "");
                valuess.ritm =
                  response.data.numinscripcion === null
                    ? ""
                    : response.data.numinscripcion.trim();
                //SelectDeuda(txtContribuyente.current.value);
                setEtiqueta("Nº Ficha Catastral");
                setVisibleF("visible");
                SelectIdComercioFact(response.data.idinmueble);
                break;
              case 3:
                txtContribuyente.current.value = response.data.idvehiculo;
                valuess.nombre =
                  response.data.nombrepropie === null
                    ? ""
                    : response.data.nombrepropie.trim();
                //txtNombre.setText("Vehículo "+rs.getString("marca").trim()+"-"+rs.getString("modelo").trim()+" Placa "+rs.getString("placa").trim());
                valuess.direccion =
                  response.data.direccionpropie === null
                    ? ""
                    : response.data.direccionpropie.trim();
                valuess.rif =
                  response.data.cedulapropie === null
                    ? ""
                    : response.data.cedulapropie.trim();
                valuess.ritm =
                  response.data.placa === null
                    ? ""
                    : response.data.placa.trim();
                setEtiqueta("Nº de Placa");
                setVisibleF("visible");
                //SelectDeuda(txtContribuyente.current.value);
                break;
              case 4:
                txtContribuyente.current.value = response.data.idcomercio;
                valuess.rif = response.data.rif;
                valuess.nombre = response.data.nombre;
                valuess.direccion = response.data.direccion;
                valuess.ritm =
                  response.data.ritm === null ? "" : response.data.ritm.trim();
                setEtiqueta("Nº de Ritm");
                setVisibleF("visible");
                //setIdComercio(response.data.idcomercio);
                //SelectDeudaC(txtContribuyente.current.value, fechaSistema, espiritu);
                break;
              case 5:
                txtContribuyente.current.value = response.data.idcomercio;
                valuess.rif = response.data.rif;
                valuess.nombre = response.data.nombre;
                valuess.direccion = response.data.direccion;
                valuess.ritm =
                  response.data.ritm === null ? "" : response.data.ritm.trim();
                setEtiqueta("Nº de Ritm");
                setVisibleF("visible");
                tipotabla = response.data.tipotabla;
                idinmue = response.data.idinmueble;

                /*SelectDeuda(txtContribuyente.current.value);
                            if (response.data.tipotabla === 1) {
                                setIdComercio(response.data.idinmueble)
                            } else {
                                SelectIdComercioFact(response.data.idrentas);
                            }*/
                break;
              case 6:
                txtContribuyente.current.value = response.data.idrentas;
                valuess.nombre =
                  response.data.nombrearrendatario === null
                    ? ""
                    : response.data.nombrearrendatario.trim();
                valuess.direccion =
                  response.data.direccion === null
                    ? ""
                    : response.data.direccion.trim();
                valuess.rif =
                  response.data.cedrif === null
                    ? ""
                    : response.data.cedrif.trim();
                setEtiqueta("Tipo de Rentas");
                setVisibleF("visible");
                tipotabla = response.data.tipotabla;
                idinmue = response.data.idinmueble;
                seleccionartipoRenta(response.data.idtiporenta);
                if (response.data.tipotabla === 1) {
                  setIdComercio(response.data.idinmueble);
                } else {
                  SelectIdComercioFact(response.data.idrentas);
                }
                break;
              case 7:
                txtContribuyente.current.value = response.data.idcomercio;
                valuess.rif = response.data.rif;
                valuess.nombre = response.data.nombre;
                valuess.direccion = response.data.direccion;
                valuess.ritm =
                  response.data.ritm === null ? "" : response.data.ritm.trim();
                setEtiqueta("Nº de Ritm");
                setVisibleF("visible");
                tipotabla = response.data.tipotabla;
                idinmue = response.data.idinmueble;
                //SelectDeuda(txtContribuyente.current.value);
                /*if (response.data.tipotabla === 1) {
                                setIdComercio(response.data.idinmueble)
                            } else {
                                SelectIdComercioFact(response.data.idrentas);
                            }*/
                break;
            }
            SelectDeuda(txtContribuyente.current.value, nomtab);
          } else {
            //if (teclas === 13) {
            setActivate(false);
            setTimeout(() => {
              setMensaje({
                mostrar: true,
                titulo: "Notificación",
                texto: "El Contribuyente no existe...",
                icono: "error",
              });
              txtContribuyente.current.value = "";
              valuess.rif = "";
              valuess.nombre = "";
              valuess.direccion = "";
              blanquear();
              txtContribuyente.current.focus();
            }, 100);
            //}
          }
        }

        //setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const validarContribuyente = (event) => {
    event.preventDefault();
    (valuess.idcontribuyente = event.target.value), (valuess.nombre = "");
    valuess.rif = "";
    valuess.direccion = "";
    setDeuda([]);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        datosContribuyente(event.target.value);
      } else {
        txtContribuyente.current.value = "";
      }
    }
  };

  const cancelar = (e) => {
    e.preventDefault();
    valuess.idcontribuyente = "";
    valuess.rif = "";
    valuess.nombre = "";
    valuess.direccion = "";
    props.onHideCancela();
    blanquear();
  };

  const onChangeValidar = (e) => {
    e.preventDefault();
    var factu = [];
    var factudet = [];
    var anioDeu = parseInt(0);
    var idDeu = parseInt(0);

    for (let i = 0; i < deuda.length; i++) {
      if (deuda[i].status === "Listo") {
        anioDeu = deuda[i].anio;
        (idDeu = deuda[i].iddeuda),
          factudet.push({
            montoimpuesto: deuda[i].monto,
            montorecargo: deuda[i].recargo,
            montointeres: deuda[i].intereses,
            periodo:
              deuda[i].fechamulta.substring(5, 7) +
              "/" +
              deuda[i].fechamulta.substring(0, 4),
            montomulta: deuda[i].multa,
            montopetro: deuda[i].monto / factorCambio,
            tipodeuda: deuda[i].tipodeuda,
          });
      }
    }
    factu.push({
      totalinmpuesto: totalSelect.montoFacturadoSelect
        .replace(/\./g, "")
        .replace(",", "."),
      totalrecargo: totalSelect.recargoSelect
        .replace(/\./g, "")
        .replace(",", "."),
      totalinteres: totalSelect.interesesSelect
        .replace(/\./g, "")
        .replace(",", "."),
      idtipoingreso: idTipIngre,
      fechaemision: fechaSistema,
      descripcion: totalSelect.concepto + " " + tipoImpu,
      tablacontribuyente: nomTablaContri,
      tabladeuda: "multa",
      iddeuda: idDeu,
      status: 0,
      nombrecontri: valuess.nombre,
      direccioncontri: valuess.direccion,
      cedrif: valuess.rif,
      totalmulta: totalSelect.multaSelect.replace(/\./g, "").replace(",", "."),
      deducible:
        parseFloat(
          totalSelect.retenSelect.replace(/\./g, "").replace(",", ".")
        ) +
        parseFloat(
          totalSelect.acrediSelect.replace(/\./g, "").replace(",", ".")
        ),
      facturador: idusuario,
      idcomercio: idComercio,
    });
    let body = {
      idcontri: parseInt(txtContribuyente.current.value, 10),
      factu: JSON.stringify(factu),
      factudet: JSON.stringify(factudet),
      nomtab: "multa",
      tipoimpu: tipoImpu,
      idingremul: idTipIngreMulta,
    };
    procesarFactura(body);
  };

  return (
    <Modal
      {...props}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {
        seleccionartipoIngreso();
        seleccionarFactorCambio();
      }}
    >
      <Modal.Header className="col-12 m-0 px-4 py-2 d-flex align-items-center justify-content-between azulGradiant">
        <h3 className="m-0fw-bold">Impresión de Facturas de Multas</h3>
        <a type="button" className="fs-6 fw-bold text-light" onClick={cancelar}>
          Salir <i className="fa fa-times ms-2"></i>
        </a>
      </Modal.Header>
      <Modal.Body className="col-12 m-0 p-2 d-flex align-items-center justify-content-between flex-wrap">
        <div className="col-8 d-flex justify-conten-end m-0 p-0">
          <label className="input-group-text">Tipo Multa:</label>
          <Select
            ref={cmbTipoImpuesto}
            id="inputStatus"
            name="municipio"
            onChange={selectTipoImpuesto}
          >
            <option value="0">Seleccione</option>
            <option value="1">ACTIVIDADES ECONOMICAS</option>
            <option value="2">INMUEBLES URBANOS</option>
            <option value="3">IMPUESTOS DE VEHICULOS</option>
            <option value="4">APUESTAS LICITAS</option>
            <option value="5">PROPAGANDA Y PUBLICIDAD COMERCIAL</option>
            <option value="6">RENTAS INMOBILIARIAS</option>
            <option value="7">RENTAS DE LICORES</option>
          </Select>
        </div>
        <div className="col-4 m-0 p-0 pl-2">
          <Input label = 'Fecha:'
            type="text"
            disabled
            id="inputTotalDeclarado"
            defaultValue={moment.utc(fechaSistema).format("DD/MM/YYYY")}
          />
        </div>
        <fieldset className="col-12 m-0 p-2 border-azul rounded d-flex flex-wrap align-items-center justify-content-between">
          <legend className="float-none m-0 w-auto">
            Datos del Contribuyente
          </legend>
          <div className="col-4 m-0 mb-2 p-0">
            <SearchInput label = 'Código:'
              name="idcontribuyente"
              ref={txtContribuyente}
              defaultValue={valuess.idcontribuyente}
              onKeyUp={validarContribuyente}
              placeholder="Código"
              onChange={onChange}
              onClickButton = {handleCatalogo}
            />
          </div>
          <div className="col-12 m-0 mb-2 p-0">
            <Input label = 'Nombres:'
              disabled
              value={valuess.nombre}
              name="nombre"
            />
          </div>
          <div className="col-12 m-0 mb-2 p-0">
            <Input label = 'Cédual/Rif:'
              disabled
              value={valuess.rif}
              name="rif"
            />
          </div>
          <div className="col-12 m-0 p-0">
            <Textarea label = 'Dirección:' 
              style={{height:70}}
              disabled
              value={valuess.direccion}
              name="direccion"
            />
          </div>
        </fieldset>
        <fieldset className="col-12 m-0 p-2 border-azul rounded">
          <legend className="float-none m-0 w-auto">Datos de la Deuda</legend>
          <div className="col-12 m-0 p-2">
            <TblContainer
              container={{ maxHeight: 180, width: "100%", overflow: "auto" }}
            >
              <TblHead />
              <tbody>
                {deuda &&
                  deuda.map((deu, index) => (
                    <tr key={index}>
                      {deu.status === "Por Pagar" ? (
                        <td className="p-0 text-center letra-tabla-td">
                          <input
                            type="checkbox"
                            ref={(el) =>
                              (chkSeleccionarDeuda.current[index] = el)
                            }
                            defaultChecked={
                              deu.status === "Por Pagar" ? false : true
                            }
                            onClick={chandleCheckDeuda(deu, index)}
                            name={"chk" + deu.mes + deu.anio}
                            style={{ width: 20, height: 20 }}
                          />
                        </td>
                      ) : (
                        <td className="p-0 text-center letra-tabla-td">
                          <input
                            type="checkbox"
                            ref={(el) =>
                              (chkSeleccionarDeuda.current[index] = el)
                            }
                            defaultChecked={true}
                            name={"chk" + deu.mes + deu.anio}
                            onClick={chandleCheckDeuda(deu, index)}
                            style={{
                              width: 20,
                              height: 20,
                            }} /* disabled={( deu.status === 'Listo' && ((tabla && tabla.tabla==='1x500') || ((deuda.length - disponiblesDeuda) === index + 1))) ? false : true} */
                          />
                        </td>
                      )}
                      {/*<td className='p-0 text-center letra-tabla-td'>{deu.anio}</td>
                                            <td className='p-0 text-center letra-tabla-td'>{deu.mes}</td>*/}
                      <td className="p-0 text-center letra-tabla-td">
                        {moment.utc(deu.fechamulta).format("DD/MM/YYYY")}
                      </td>
                      <td className="p-0 text-left letra-tabla-td">
                        {deu.descripcion.trim()}
                      </td>
                      <td className="p-0 text-left letra-tabla-td">
                        {deu.concepto.trim()}
                      </td>
                      <td className="p-0 text-end letra-tabla-td">
                        {formatMoneda(
                          deu.monto
                            .toString()
                            .replace(",", "")
                            .replace(".", ","),
                          ",",
                          ".",
                          2
                        )}
                      </td>
                    </tr>
                  ))}
              </tbody>
            </TblContainer>
            <div className="col-12 m-0 mt-2 p-0 d-flex justify-content-between">
              <div className="col-6 m-0 p-0">
                <Textarea label = 'Concepto:'
                  style={{ height: "70px" }}
                  id="inputTotalDeclarado"
                  defaultValue={totalSelect.concepto}
                />
              </div>
              <div className="col-6 m-0 p-0 pl-2">
                <div className="w-100 col-12 m-0 mb-2 p-0 border-bottom" style={{ visibility: visibleF }}>
                  <Input label = {etiqueta}
                    value={valuess.ritm}
                    id="inputTotalDeclarado"
                  />
                </div>
                <div className="w-100 col-12 m-0 mb-2 p-0 border-bottom">
                  <Input label = 'Facturado:'
                    disabled
                    id="inputTotalDeclarado"
                    defaultValue={totalSelect.montoFacturadoSelect}
                  />
                </div>
                <div className="w-100 col-12 m-0 mb-2 p-0 border-bottom">
                  <Input label = 'Intereses por Mora:'
                    disabled
                    id="inputTotalDeclarado"
                    defaultValue={totalSelect.interesesSelect}
                  />
                </div>
                <div className="w-100 col-12 m-0 mb-2 p-0 border-bottom">
                  <Input label = 'Recargos por Mora:'
                    disabled
                    id="inputTotalDeclarado"
                    defaultValue={totalSelect.recargoSelect}
                  />
                </div>
                <div className="w-100 col-12 m-0 p-0 border-bottom">
                  <Input label = 'Monto Total a Facturar'
                    disabled
                    id="inputTotalDeclarado"
                    defaultValue={totalSelect.montoseleccionado}
                  />
                </div>
              </div>
            </div>
          </div>
        </fieldset>
      </Modal.Body>
      <Modal.Footer>
        <SuccessButton
          disabled={btnDisabled}
          onClick={onChangeValidar}
        >
            Aceptar
        </SuccessButton>
        <DangerButton onClick={cancelar}>
            Cancelar
        </DangerButton>
      </Modal.Footer>

      <Dimmer active={activate} inverted></Dimmer>
      <Mensaje
        mensaje={mensaje}
        onHide={() =>
          setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
        onHideSi={handleCloseSi}
      />
      <CatalogoComercio
        titulo={titulo}
        mensaje={msg}
        show={catalogoC}
        onHideCancelaCatCom={handleCatalogo}
        onHideAceptaCatCom={handleAceptaCatalogo}
      />
    </Modal>
  );
};
